import initialState from '../store/initial-state'
import {
  TOURS_DASHBOARD_SUCCESS,
  TOURS_DASHBOARD_FAILURE,
  TOURS_MENU_SUCCESS,
  TOURS_MENU_FAILURE,
  TOURS_EXPLORE_SUCCESS,
  TOURS_EXPLORE_FAILURE,
  TOURS_USERS_SUCCESS,
  TOURS_USERS_FAILURE,
  TOURS_GROUPS_SUCCESS,
  TOURS_GROUPS_FAILURE,
  TOURS_MENU_FILTERS,
  TOURS_DASHBOARD_FILTERS,
  TOURS_MENU_STATE,
  TOURS_DASHBOARD_STATE,
  TOURS_MENU_ONLY_VIEW
} from '../constants/tours-types'

export default (state = initialState.tours, action) => {
  switch (action.type) {

    case TOURS_DASHBOARD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tourDashboard: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case TOURS_DASHBOARD_FAILURE:
      return {
        ...state,
        isFetching: false,
        tourDashboard: [],
        headers: null,
        error: action.payload
      }

    case TOURS_MENU_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tourMenu: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case TOURS_MENU_FAILURE:
      return {
        ...state,
        isFetching: false,
        tourMenu: [],
        headers: null,
        error: action.payload
      }

    case TOURS_USERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tourUsers: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case TOURS_USERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        tourUsers: [],
        headers: null,
        error: action.payload
      }

    case TOURS_GROUPS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tourGroups: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case TOURS_GROUPS_FAILURE:
      return {
        ...state,
        isFetching: false,
        tourGroups: [],
        headers: null,
        error: action.payload
      }
    case TOURS_EXPLORE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tourExplore: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case TOURS_EXPLORE_FAILURE:
      return {
        ...state,
        isFetching: false,
        tourExplore: [],
        headers: null,
        error: action.payload
      }
      
    case TOURS_MENU_FILTERS:
      return {
        ...state,
        tourMenuFilters: action.payload.data,
      }
    case TOURS_MENU_STATE: 
      return {
        ...state,
        tourMenuFiltersFinished: action.payload.data,
      }
    case TOURS_DASHBOARD_FILTERS:
      return {
        ...state,
        tourDashboardFilters: action.payload.data,
      }
    case TOURS_DASHBOARD_STATE: 
      return {
        ...state,
        tourDashboardFiltersFinished: action.payload.data,
      }
    case TOURS_MENU_ONLY_VIEW: 
      return {
        ...state,
        tourMenuFilters: [],
        tourMenuOnlyView: action.payload.tourMenuOnlyView,
      }
    default: return { ...state }
  }
  
}
